/**
  * Window Popup Helper
  *
  * This code is borrowed from https://creativemarket.com
  * This function can be used to create a popup window with a given source.
  *
  * Usage:
  *  popup({u: "http://url.to/open/here"})
  *
  * Options:
  *  u - url to open (required)
  *  w - width of the window to create [default: 650]
  *  h - height of the window to create [default: 280]
  *  n - name of the window to set [default: '']
  */
module.exports = function(options) {
  var width = options.w || 650;
  var height = options.h || 280;
  var screenX = 'undefined' !== typeof window.screenX ? window.screenX : window.screenLeft;
  var screenY = 'undefined' !== typeof window.screenY ? window.screenY : window.screenTop;
  var outerWidth = 'undefined' !== typeof window.outerWidth ? window.outerWidth : document.documentElement.clientWidth;
  var outerHeight = 'undefined' !== typeof window.outerHeight ? window.outerHeight : document.documentElement.clientHeight - 22;
  var x = 0 > screenX ? window.screen.width + screenX : screenX;
  var left = parseInt(x + (outerWidth - width) / 2, 10);
  var top = parseInt(screenY + (outerHeight - height) / 2.5, 10);
  window.open(options.u, options.n || '', 'scrollbars=no,menubar=no,resizable=yes,toolbar=no,location=no,status=yes,left=' + left + ',' + 'top=' + top + ',' + 'width=' + width + ',' + 'height=' + height).focus();
};
